module.exports = __webpack_public_path__ + "img/customer_focused.37aea979.png";